import { StyleSheet, View } from 'react-native';

import { DefaultLayout, HeaderBackButton, Text, spacing } from '@pletly/ui';
import { RootStackScreenProps } from '../../../navigation';
import { TermsInput } from './components/TermsInput';

type Props = RootStackScreenProps<'TermsOfUseView'>;

export const TermsOfUseView = ({
	route: {
		params: { text, updatedAt },
	},
}: Props) => {
	return (
		<DefaultLayout view style={styles.root}>
			<HeaderBackButton />

			<View style={styles.container}>
				<Text align="right" appearance="hint" style={styles.createdOn}>
					{updatedAt}
				</Text>
				<TermsInput text={text} />
			</View>
		</DefaultLayout>
	);
};

const styles = StyleSheet.create({
	root: {
		gap: 0,
		marginVertical: spacing(2),
	},
	container: { width: '100%', gap: spacing() },
	createdOn: { width: '100%', paddingHorizontal: spacing() },
});
